import { render, staticRenderFns } from "./Sondaggi.vue?vue&type=template&id=705d4bd4&scoped=true&"
import script from "./Sondaggi.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Sondaggi.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Sondaggi.vue?vue&type=style&index=0&id=705d4bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d4bd4",
  null
  
)

export default component.exports